import CancelModalButton from "../../UIElements/CustomModal/CancelModalButton";

import { useLocalStorage } from "../../../hooks";
import { RoleNamesEnum, RolesEnum, Session } from "../../../types";
import { sessionStorageKey } from "../../../consts";
import { useState } from "react";

import { Box } from "@mui/material";
import CustomButton from "../../UIElements/CustomButton";
import AccountSwitcherForm from "../../Forms/AccountSwictherForm";

export default function AccountSwictherModal() {
    const { setValue, storedValue: session } =
        useLocalStorage<Session>(sessionStorageKey);
    const {
        auth: { user: currentUser, currentUserRoleId },
    } = session;

    const filteredGroups = currentUser.groups.filter(
        (g) =>
            ![
                RolesEnum.CLIENT,
                RolesEnum.INSTRUCTEUR,
                RolesEnum.ADMIN_REGION,
                RolesEnum.ADMIN_RESEAU,
            ].includes(g)
    );

    const rolesOptions = filteredGroups.map((g) => {
        return { id: g, name: RoleNamesEnum[g] };
    });

    const defaultValue = rolesOptions.find((r) => r.id === currentUserRoleId);

    const [selectedUserRoleId, setSelectedUserRoleId] = useState<RolesEnum>(
        RolesEnum.ADMIN
    );

    const handleAccountSwitch = async (selectedValue: number) => {
        setSelectedUserRoleId(selectedValue);
    };
    const handleSubmit = () => {
        if (null !== selectedUserRoleId) {
            session.auth.currentUserRoleId = selectedUserRoleId;
            setValue(session);
            window.location.reload();
        }
    };
    return (
        <Box
            component="form"
            onSubmit={handleSubmit}
            noValidate
            sx={{ display: "flex", flexDirection: "column", gap: 2 }}
        >
            <AccountSwitcherForm
                defaultValue={defaultValue}
                options={rolesOptions}
                onSelect={handleAccountSwitch}
            />
            <CustomButton
                type="submit"
                label="Valider"
                customsx={{
                    "@media (max-width:1024px)": {
                        width: "100%",
                    },
                }}
            />
            <CancelModalButton
                customsx={{
                    width: "100%",
                }}
            />
        </Box>
    );
}
